module.exports = __webpack_public_path__ + "img/3b7bb13.svg";